var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgTrainingCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3D82F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.394 14.451H8.688v14.705h21.706zm-.001-3.921H8.687v3.056h21.706z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.105 10.547h-2.008V8.946c0-.18.144-.327.321-.327h1.35c.176 0 .321.147.321.327v1.6z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.097 10.547h1.992v1.618c0 .18-.145.326-.321.326h-1.35a.325.325 0 0 1-.321-.326z",
    fill: "#3D82F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.983 10.547H25.99V8.946c0-.18.145-.327.322-.327h1.35c.176 0 .32.147.32.327z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.99 10.547h1.993v1.618c0 .18-.145.326-.322.326h-1.35a.325.325 0 0 1-.32-.326zm-8.772 14.966a2.5 2.5 0 0 1-1.044-.213 2.3 2.3 0 0 1-.836-.604 2.4 2.4 0 0 1-.514-.932l1.045-.294a1.36 1.36 0 0 0 1.334 1.013q.408 0 .722-.196c.209-.13.37-.294.482-.506a1.55 1.55 0 0 0 .177-.736c0-.424-.129-.768-.386-1.045-.257-.278-.594-.409-.996-.409-.112 0-.24.017-.353.05a1.6 1.6 0 0 0-.338.13l-.498-.866 2.619-2.353.112.31h-3.63v-1.045h4.482v1.046l-2.185 2.124-.016-.36c.466 0 .867.098 1.221.31.337.213.61.507.803.867s.29.768.29 1.209a2.45 2.45 0 0 1-1.238 2.173 2.5 2.5 0 0 1-1.253.326m5.11-.146v-6.34l-1.398.866v-1.225l1.398-.85h1.092v7.549z",
    fill: "#3D82F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingCalendar);
export default __webpack_public_path__ + "static/media/TrainingCalendar.dc3a6306c9e6a36c6bff6069a015405a.svg";
export { ForwardRef as ReactComponent };